module.exports = __webpack_public_path__ + "media/images/icons/arrow-down-986fe12b4538f7573374ffd9114dfe29.svg";